// ============================================
// components/common/NotificationAlert.js
// ============================================
import React from 'react';
import { Snackbar, Alert, AlertTitle } from '@mui/material';

const NotificationAlert = ({ notification, severity = 'success', onClose, autoHideDuration = 3000, dataTestId = 'notification-alert' }) => {
  const open = Boolean(notification?.open);
  const title = notification?.title || null;
  const message = notification?.message || '';

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    if (onClose) onClose();
  };

  // If not open, render nothing to keep the DOM clean for accessibility audits
  if (!open) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }} data-testid={dataTestId}>
        {title ? <AlertTitle component="p">{title}</AlertTitle> : null}
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationAlert;
